/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PotentialConditionsPotentialCondition,
    PotentialConditionsPotentialConditionFromJSON,
    PotentialConditionsPotentialConditionFromJSONTyped,
    PotentialConditionsPotentialConditionToJSON,
} from './';

/**
 * 
 * @export
 * @interface PotentialConditions
 */
export interface PotentialConditions {
    /**
     * 
     * @type {Array<PotentialConditionsPotentialCondition>}
     * @memberof PotentialConditions
     */
    potentialCondition?: Array<PotentialConditionsPotentialCondition> | null;
}

export function PotentialConditionsFromJSON(json: any): PotentialConditions {
    return PotentialConditionsFromJSONTyped(json, false);
}

export function PotentialConditionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PotentialConditions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'potentialCondition': !exists(json, 'potentialCondition') ? undefined : (json['potentialCondition'] === null ? null : (json['potentialCondition'] as Array<any>).map(PotentialConditionsPotentialConditionFromJSON)),
    };
}

export function PotentialConditionsToJSON(value?: PotentialConditions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'potentialCondition': value.potentialCondition === undefined ? undefined : (value.potentialCondition === null ? null : (value.potentialCondition as Array<any>).map(PotentialConditionsPotentialConditionToJSON)),
    };
}


